import { SIBASI_APPS } from 'src/app/common/model/sibasi-system.model';

export const environment = {
  activeApp: SIBASI_APPS.EBMSUITE,
  production: true,
  clientId: '53cd08ee202f46c99b6112a2bc65a147', // DEV
  api_url: 'https://api.ebmsuite.com/'
};
